//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// custom pages
import Logo from "assets/img/logo.png";
import { loginStyles } from "./styles";
import Context from "context/context";
// import { redirectionLinks } from "./redirectionLinks";


// ant-design
import { Row, Col } from "antd";

// ant-design icons
import GlobalOutlined from "@ant-design/icons/GlobalOutlined";
import FacebookFilled from "@ant-design/icons/FacebookFilled";
import InstagramOutlined from "@ant-design/icons/InstagramOutlined";
import TwitterOutlined from "@ant-design/icons/TwitterOutlined";
import LinkedinFilled from "@ant-design/icons/LinkedinFilled";
import YoutubeFilled from "@ant-design/icons/YoutubeFilled";
import auth from "apis/auth/auth";

export default function LoginParent(props) {
  const location = useLocation();
  const classes = loginStyles();
  const { state, dispatch } = useContext(Context);
  const { redirection } = auth();
  const[redirectionlink,setredirection]= useState([])

  useEffect(()=>{
    fetchImages()


  },[])

  const fetchImages = async () => {
    try {
      const response = await redirection();
    setredirection(response.data)
    } catch (error) {
      console.error("Failed to fetch banner images:", error);
    }
  };

 

const redirectionLinks = {
  HS_Webite: redirectionlink.find(item => item.link_name === 'HENRY_SCHEIN_DENTAL_WEBSITE')?.link_url,
  HS_Facebook: redirectionlink.find(item => item.link_name === 'FACEBOOK_ICON')?.link_url,
  HS_Instagram: redirectionlink.find(item => item.link_name === 'INSTAGRAM_ICON')?.link_url,
  HS_Twitter: redirectionlink.find(item => item.link_name === 'TWITTER_ICON')?.link_url,
  HS_LinkedIn: redirectionlink.find(item => item.link_name === 'LINKEDIN_ICON')?.link_url,
  HS_Youtube: redirectionlink.find(item => item.link_name === 'YOUTUBE_ICON')?.link_url
};




  return (
    <Row className={classes.row}>
      <Col
        xs={{ span: 24 }}
        sm={{ span: 15 }}
        lg={{ span: 15 }}
        className={classes.leftCol}
      >
        <div className={classes.imgDiv}>
          <img src={Logo} className={classes.img} alt="logo" />
        </div>
        <div className={classes.contentDiv}>
          <div>
            {location.pathname == "/login" && "Welcome back!"}
            {location.pathname == "/forgotpassword" && "Don't worry"}
            {location.pathname == "/verify-otp" && "Security first"}
          </div>

          {location.pathname == "/login" && (
            <div className={classes.descriptionDiv}>
              Earn points from anything you buy. <br />
              Redeem points towards your invoice.
            </div>
          )}
          {location.pathname == "/forgotpassword" && (
            <div className={classes.descriptionDiv}>
              We are here to help you recover your password. Enter the email{" "}
              <br /> address you used when you joined and we will send an OTP to{" "}
              <br /> verify your email and let you reset your password
            </div>
          )}
          {location.pathname == "/verify-otp" && (
            <div className={classes.descriptionDiv}>
              We care about your security. To confirm that its you who have{" "}
              <br /> made the request to reset the password, we have send an{" "}
              <br /> OTP to you email ID please enter the OTP here.
            </div>
          )}
        </div>
        <div className={classes.iconDiv}>
          <a href={redirectionLinks?.HS_Webite} style={{ color: "#fff" }} target="_blank"><GlobalOutlined className={classes.icon} /></a>
          <a href={redirectionLinks?.HS_Facebook} style={{ color: '#fff' }} target="_blank"><FacebookFilled className={classes.icon} /></a>
          <a href={redirectionLinks?.HS_Instagram} style={{ color: "#fff" }} target="_blank"><InstagramOutlined className={classes.icon} /></a>
          <a href={redirectionLinks?.HS_Twitter} style={{ color: '#fff' }} target="_blank"><TwitterOutlined className={classes.icon} /></a>
          <a href={redirectionLinks?.HS_LinkedIn} style={{ color: "#fff" }} target="_blank"><LinkedinFilled className={classes.icon} /></a>
          <a href={redirectionLinks?.HS_Youtube} style={{ color: "#fff" }} target="_blank"><YoutubeFilled className={classes.icon} /></a>
        </div>
      </Col>
      <Col
        xs={{ span: 24 }}
        sm={{ span: 9 }}
        lg={{ span: 9 }}
        className={classes.rightCol}
      >
        {props.children}
      </Col>
    </Row>
  );
}
